const InstagramIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="12" cy="12" r="4.1" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="17.15" cy="6.85" r="1" fill="currentColor" />
    </svg>
);

const SiteFooter = () => (
    <footer className="siteFooter">
        <img className="siteFooterLogo" src="/images/logo.png" alt="Delaney Stewart" />
        <a
            className="siteFooterInstagram"
            href="https://www.instagram.com/dnystu/"
            target="_blank"
            rel="noreferrer"
        >
            <InstagramIcon />
            @dnystu
        </a>
        <div className="siteFooterText">&copy; {new Date().getFullYear()} Prints by Delaney Stewart</div>
    </footer>
);

export default SiteFooter;
